import i18n from './i18n';

export const LOCAL_STORAGE_LANG_KEY = 'i18nLng';

export function normalizeLang(code) {
    if (!code || typeof code !== 'string') return null;
    const c = code.toLowerCase();
    // Convert like en-US -> en
    const short = c.split('-')[0];
    // Accept 2-5 len codes, fallback to short
    if (short && short.length >= 2 && short.length <= 5) return short;
    if (c.length >= 2 && c.length <= 5) return c;
    return null;
}

export function detectClientLang() {
    try {
        const tgCode = window?.Telegram?.WebApp?.initDataUnsafe?.user?.language_code;
        const navi = typeof navigator !== 'undefined' ? navigator.language : null;
        return normalizeLang(tgCode) || normalizeLang(navi) || null;
    } catch {
        return null;
    }
}

export function applyLanguage(lang) {
    if (!lang) return;
    const normalized = normalizeLang(lang) || 'ru';
    try {
        i18n.changeLanguage(normalized);
    } catch { }
    try {
        localStorage.setItem(LOCAL_STORAGE_LANG_KEY, normalized);
    } catch { }
}
